import CT from '@marketplace-ai/tags';
import { ShiftDifferentialType } from '~/types/hlx/enums';
const TAGS = CT.employer.negotiation.negotiationDetails;

export const TABS = [
  {
    name: 'Contract Overview',
    current: true,
    cyTag: TAGS.contractOverviewTab,
  },
  {
    name: 'Shift Distribution',
    current: false,
    cyTag: TAGS.shiftDistributionTab,
  },
  {
    name: 'Compensation',
    current: false,
    cyTag: TAGS.compensationTab,
  },
  {
    name: 'Contract Terms',
    current: false,
    cyTag: TAGS.contractTermsTab,
  },
];

export const COMP_TYPE_OPTIONS = [
  { label: 'Hourly ($/hour)', value: 'HOUR' },
  { label: 'Per Shift ($/shift)', value: 'SHIFT' },
  { label: 'RVU Based ($/RVU)', value: 'RVU' },
];

export const SHIFT_DIFF_TYPE_OPTIONS = [
  { label: 'Incremental Amount ($/hour)', value: ShiftDifferentialType.INCR_HOURLY_RATE },
  { label: 'Multiplier (x Base Rate)', value: ShiftDifferentialType.MULTIPLIER },
  { label: 'RVU Rate', value: ShiftDifferentialType.RVU },
  { label: 'Fixed Hourly Rate', value: ShiftDifferentialType.HOURLY_RATE },
];
